import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';

const navBarCss = ":host{width:100%}.navbar{display:flex;background-color:var(--hmc-color-layout-container, var(--hmc-color-gray-white, #fff));border-bottom:1px solid var(--hmc-color-layout-divider-default, var(--hmc-color-gray-300, #b7bbc3))}.navbar .left-actions{flex:0 0 25%;display:flex;margin-right:auto}.navbar .left-side-bar{display:flex;border-right:1px solid var(--hmc-color-layout-divider-default, var(--hmc-color-gray-300, #b7bbc3));justify-content:center;flex-direction:column}.navbar .logo{align-self:center}.navbar .links{padding:8px 0;display:flex;gap:4px;flex:1 0 0;justify-content:center;align-items:center}.navbar .right-actions{flex:0 0 25%;display:flex;align-items:center;margin-left:auto;justify-content:flex-end}";

const HmcNavBar$1 = /*@__PURE__*/ proxyCustomElement(class HmcNavBar extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.leftActionsEnabled = false;
  }
  render() {
    const { leftActionsEnabled } = this;
    const classList = {
      navbar: true,
    };
    return (h("nav", { class: classList }, h("div", { class: "left-actions" }, leftActionsEnabled && (h("div", { class: "left-side-bar" }, h("slot", { name: "left-actions" }))), h("div", { class: "logo" }, h("slot", { name: "logo" }))), h("div", { class: "links", role: "list" }, h("slot", null)), h("div", { class: "right-actions" }, h("slot", { name: "right-actions" }))));
  }
  get el() { return this; }
  static get style() { return navBarCss; }
}, [1, "hmc-nav-bar", {
    "leftActionsEnabled": [4, "enable-left-actions"]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["hmc-nav-bar"];
  components.forEach(tagName => { switch (tagName) {
    case "hmc-nav-bar":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, HmcNavBar$1);
      }
      break;
  } });
}

const HmcNavBar = HmcNavBar$1;
const defineCustomElement = defineCustomElement$1;

export { HmcNavBar, defineCustomElement };
